import { AxiosResponse } from "axios";
import config from "../../../../config/config";
import ApiClient from "../../ApiClient";
import { IMappingEquipment, IMappingEquipmentAddRequest, IMappingEquipmentUpdateRequest } from "./types";
import fileDownload from "js-file-download";

const equipmentApi = new ApiClient("/Equipment", config.api.baseUrl);

/**
 * Returns a list of all equipment.
 * @param token
 */
export const getEquipmentCatalogue = (token: string): Promise<IMappingEquipment[]> => {
    ApiClient.setAuthorizationToken(token);

    return equipmentApi
        .get("/list", {
            clearCacheEntry: true,
        })
        .then((response: AxiosResponse<IMappingEquipment[]>) => {
            return Promise.resolve(response.data);
        });
};

/**
 * Create equipment into catalogue and return created entity.
 * @param token
 * @param data
 */
export const addEquipmentCatalogue = (token: string, data: IMappingEquipmentAddRequest): Promise<IMappingEquipment> => {
    ApiClient.setAuthorizationToken(token);

    return equipmentApi.post("/add", data).then((response: AxiosResponse<IMappingEquipment>) => {
        return Promise.resolve(response.data);
    });
};

/**
 * Update equipment in catalogue and return updated entity.
 * @param token
 * @param equipmentID
 * @param data
 */
export const updateEquipmentCatalogue = (
    token: string,
    equipmentID: number,
    data: IMappingEquipmentUpdateRequest
): Promise<IMappingEquipment> => {
    ApiClient.setAuthorizationToken(token);

    return equipmentApi.post(`/${equipmentID}/update`, data).then((response: AxiosResponse<IMappingEquipment>) => {
        return Promise.resolve(response.data);
    });
};

/**
 * Deletes equipment from catalogue.
 * @param token
 * @param equipmentID
 */
export const deleteEquipmentCatalogue = (token: string, equipmentID: number): Promise<boolean> => {
    ApiClient.setAuthorizationToken(token);

    return equipmentApi.get(`/${equipmentID}/delete`).then((response: AxiosResponse<boolean>) => {
        return Promise.resolve(response.status === 204);
    });
};

/**
 * Export equipment, file is downloaded
 * @param token
 */
export const exportEquipment = (
    token: string
): Promise<void> => {
    ApiClient.setAuthorizationToken(token);

    return equipmentApi
        .get(`/export`, {
            responseType: "blob"
        })
        .then((response) => {
            // Promise.resolve(response.data)
            fileDownload(response.data, "equipment.xlsx");
            return;
        });
};

/**
 * Import equipment, file is uploaded
 * @param token
 * @param data
 */
export const importEquipment = (
    token: string,
    data: FormData
): Promise<void> => {
    ApiClient.setAuthorizationToken(token);

    return equipmentApi
        .post(`/import`, data, {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        })
        .then((response) => {
            return Promise.resolve(response.data);
        })
        .catch((response) => {
            return Promise.reject(response.data);
        });
};